import toast from 'react-hot-toast';

// Success toast - for successful operations
export const showSuccess = (message) => {
  toast.success(message);
};

// Error toast - for errors and failures
export const showError = (message) => {
  toast.error(message);
};

// Info toast - for general information
export const showInfo = (message) => {
  toast(message, {
    icon: 'ℹ️',
  });
};

// Warning toast - for warnings
export const showWarning = (message) => {
  toast(message, {
    icon: '⚠️',
    style: {
      background: '#FBBF24',
      color: '#000',
    },
  });
};

// Promise toast - for async operations with loading state
export const showPromise = (promise, messages) => {
  return toast.promise(promise, {
    loading: messages.loading || 'Loading...',
    success: messages.success || 'Success!',
    error: messages.error || 'Something went wrong',
  });
};

export default toast;
